(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('NotificationsHelpController', NotificationsHelpController);

    NotificationsHelpController.$inject = ['$state', '$uibModalInstance'];

    function NotificationsHelpController($state, $uibModalInstance) {
        var vm = this;

        vm.notifications = [
            { icon: 'fa fa-circle fa-lg', iconColor: 'color-green', description: "Channel configured, active notifications"},
            { icon: 'fa fa-circle fa-lg', iconColor: 'background-red', description: " Channel configured, inactive notification due to stopped rule or disabled notification (single rule or general setting)"},
            { icon: 'fa fa-circle fa-lg', iconColor: 'color-gray', description: "Not configured or disabled by domain admin"}
        ]

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }
})();
